import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Stack,
  Typography,
  Button,
  CircularProgress,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
} from '@mui/material';

export default function ClosureEmployeeContractModal({
  open,
  onClose,
  employee,
  onSave,
  saving,
}) {
  const [mode, setMode] = useState('HORA');
  const [amount, setAmount] = useState('');

  useEffect(() => {
    if (open && employee) {
      const initialMode = employee.salaryMode || 'HORA';
      setMode(initialMode);
      setAmount(initialMode === 'HORA' ? (employee.hourlyRate || '') : (employee.baseSalary || ''));
    }
  }, [open, employee]);

  const handleSave = () => {
    const payload = {
      salaryMode: mode,
      hourlyRate: mode === 'HORA' ? String(amount) : null,
      baseSalary: mode === 'MENSUAL' ? String(amount) : null,
    };
    onSave(payload);
  };

  const isFormValid = amount !== '' && !isNaN(Number(amount)) && Number(amount) >= 0;

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: 'white',
          borderRadius: '24px',
          p: 1,
        },
      }}
    >
      <DialogContent sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 4 }}>
        
        {/* Fila de Inputs (Select y Monto) */}
        <Stack direction="row" spacing={2} alignItems="flex-start">
          
          {/* Columna de Tipo */}
          <Stack spacing={1} sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'primary.900', ml: 0.5 }}>
              Tipo
            </Typography>
            <Select
              value={mode}
              onChange={(e) => setMode(e.target.value)}
              disabled={saving}
              sx={{
                borderRadius: '16px',
                fontWeight: 700,
                fontSize: 15,
                height: 52, 
                color: 'primary.900',
                bgcolor: 'neutral.50',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'neutral.300', borderWidth: 2 },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.400' },
              }}
            >
              <MenuItem value="HORA" sx={{ fontWeight: 600 }}>Hora</MenuItem>
              <MenuItem value="MENSUAL" sx={{ fontWeight: 600 }}>Mensual</MenuItem>
            </Select>
          </Stack>

          {/* Columna de Monto */}
          <Stack spacing={1} sx={{ flex: 1.5 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'primary.900', ml: 0.5 }}>
              Monto
            </Typography>
            <TextField
              variant="outlined"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              disabled={saving}
              placeholder="0.00"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={{ fontWeight: 800, color: 'primary.900' }}>$</Typography>
                  </InputAdornment>
                ),
                style: { fontWeight: 700, fontSize: 16 },
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '16px',
                  height: 52,
                  bgcolor: 'neutral.50',
                  '& fieldset': { borderColor: 'neutral.300', borderWidth: 2 },
                  '&:hover fieldset': { borderColor: 'primary.400' },
                },
              }}
            />
          </Stack>
        </Stack>

        {/* Botones de Acción (Más chicos) */}
        <Stack direction="row" sx={{ px: 1, pb: 1, justifyContent: 'flex-end', gap: 1.5, flexShrink: 0 }}>
          <Button
            onClick={onClose}
            disabled={saving}
            variant="outlined" 
            sx={{ 
              textTransform: 'none', 
              borderRadius: '24px', 
              px: 3, 
              py: 0.6,
              fontSize: 14, 
              color: 'primary.900', 
              borderColor: 'neutral.400', 
              fontWeight: 700 
            }}
          >
            Cancelar
          </Button>

          <Button
            onClick={handleSave}
            disabled={saving || !isFormValid}
            variant="contained" 
            color="primary" 
            sx={{ 
              textTransform: 'none', 
              borderRadius: '24px', 
              px: 3, 
              py: 0.6,
              fontSize: 14, 
              fontWeight: 700, 
              display: 'flex', 
              gap: 1 
            }}
          >
            {saving ? <CircularProgress size={18} color="inherit" /> : 'Guardar'}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}